(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      const messages = Array.from(this.querySelectorAll('.vlp-announcement__msg'));
      if (messages.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const step = 4.5;
      const duration = messages.length * step;
      messages.forEach((message, index) => {
        message.style.animationDuration = duration + 's';
        message.style.animationDelay = (-index * step) + 's';
      });
      this.classList.add('is-rotating');
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-qty-minus]').forEach((b) => {
        b.addEventListener('click', () => this.step(b, -1));
      });
      this.querySelectorAll('[data-qty-plus]').forEach((b) => {
        b.addEventListener('click', () => this.step(b, 1));
      });
      this.querySelectorAll('[data-remove]').forEach((b) => {
        b.addEventListener('click', () => this.change(this.lineOf(b), 0));
      });
    }

    lineOf(el) {
      const row = el.closest('[data-line]');
      return row ? row.dataset.line : null;
    }

    step(btn, delta) {
      const row = btn.closest('[data-line]');
      if (!row) return;
      const qtyEl = row.querySelector('[data-qty]');
      let quantity = Number(qtyEl ? qtyEl.textContent : 1) || 1;
      quantity = Math.max(1, quantity + delta);
      this.change(row.dataset.line, quantity);
    }

    async change(line, quantity) {
      if (line == null) return;
      this.classList.add('is-busy');
      const sectionId = this.dataset.sectionId;
      try {
        const body = { line: Number(line), quantity: quantity };
        if (sectionId) {
          body.sections = sectionId;
          body.sections_url = window.location.pathname;
        }
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        this.updateCount(data.item_count);
        if (sectionId && data.sections && data.sections[sectionId]) {
          this.replaceSection(sectionId, data.sections[sectionId]);
        } else {
          window.location.reload();
        }
      } catch (error) {
        window.location.reload();
      }
    }

    updateCount(count) {
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    replaceSection(sectionId, html) {
      const wrapper = document.getElementById('shopify-section-' + sectionId);
      if (!wrapper) {
        window.location.reload();
        return;
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.getElementById('shopify-section-' + sectionId) || parsed.body;
      const incoming = source ? source.querySelector('.vlp-cart') : null;
      const current = wrapper.querySelector('.vlp-cart');
      if (incoming && current) {
        current.replaceWith(incoming);
      } else {
        wrapper.innerHTML = html;
      }
    }
  }

  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  class CollectionGrid extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      if (!this.grid) return;
      this.instock = this.querySelector('[data-instock]');
      this.cards = Array.from(this.grid.querySelectorAll('[data-card]'));
      this.emptyMsg = this.querySelector('[data-grid-empty]');

      this.filter = this.querySelector('[data-filter]');
      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterPanel = this.querySelector('[data-filter-panel]');
      this.filterBadge = this.querySelector('[data-filter-badge]');
      const filterReset = this.querySelector('[data-filter-reset]');

      this.catButtons = Array.from(this.querySelectorAll('[data-cat-value]'));
      this.currentCat = '';

      this.sortWrap = this.querySelector('[data-sortwrap]');
      this.sortToggle = this.querySelector('[data-sort-toggle]');
      this.sortMenu = this.querySelector('[data-sort-menu]');
      this.sortLabel = this.querySelector('[data-sort-label]');
      this.sortOptions = Array.from(this.querySelectorAll('[data-sort-value]'));
      this.currentSort = 'featured';

      if (this.instock) this.instock.addEventListener('change', () => this.apply());

      this.catButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.selectCat(btn));
      });

      if (this.filterToggle && this.filterPanel) {
        this.filterToggle.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleFilter();
        });
      }
      if (filterReset) filterReset.addEventListener('click', () => this.resetFilters());

      if (this.sortToggle && this.sortMenu) {
        this.sortToggle.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleSort();
        });
      }
      this.sortOptions.forEach((opt) => {
        opt.addEventListener('click', () => this.selectSort(opt));
      });

      document.addEventListener('click', (event) => {
        if (this.filter && !this.filter.contains(event.target)) this.closeFilter();
        if (this.sortWrap && !this.sortWrap.contains(event.target)) this.closeSort();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeFilter();
          this.closeSort();
        }
      });

      if (this.cards.length) this.apply();
    }

    apply() {
      const sort = this.currentSort || 'featured';
      const cat = this.currentCat || '';
      const onlyStock = this.instock ? this.instock.checked : false;
      const num = (el, attr) => parseFloat(el.getAttribute(attr)) || 0;
      const text = (el) => el.getAttribute('data-title') || '';

      const list = this.cards.slice();
      if (sort === 'price-asc') list.sort((a, b) => num(a, 'data-price') - num(b, 'data-price'));
      else if (sort === 'price-desc') list.sort((a, b) => num(b, 'data-price') - num(a, 'data-price'));
      else if (sort === 'title-asc') list.sort((a, b) => text(a).localeCompare(text(b)));
      else if (sort === 'title-desc') list.sort((a, b) => text(b).localeCompare(text(a)));
      else if (sort === 'newest') list.sort((a, b) => num(b, 'data-date') - num(a, 'data-date'));

      let visible = 0;
      list.forEach((card) => {
        const inCat = !cat || (card.getAttribute('data-collections') || '').split(' ').indexOf(cat) !== -1;
        const inStock = !onlyStock || card.getAttribute('data-available') === 'true';
        const show = inCat && inStock;
        card.style.display = show ? '' : 'none';
        if (show) visible += 1;
        this.grid.appendChild(card);
      });

      if (this.emptyMsg) this.emptyMsg.hidden = visible > 0;

      let active = 0;
      if (cat) active += 1;
      if (onlyStock) active += 1;
      this.updateBadge(active);
    }

    updateBadge(count) {
      if (!this.filterBadge) return;
      if (count > 0) {
        this.filterBadge.textContent = count;
        this.filterBadge.hidden = false;
      } else {
        this.filterBadge.hidden = true;
      }
    }

    selectCat(btn) {
      this.currentCat = btn.getAttribute('data-cat-value') || '';
      this.catButtons.forEach((b) => b.classList.toggle('is-active', b === btn));
      this.apply();
    }

    toggleFilter() {
      if (this.filterPanel.hidden) this.openFilter();
      else this.closeFilter();
    }

    openFilter() {
      this.closeSort();
      this.filterPanel.hidden = false;
      this.filterToggle.setAttribute('aria-expanded', 'true');
      if (this.filter) this.filter.classList.add('is-open');
    }

    closeFilter() {
      if (!this.filterPanel) return;
      this.filterPanel.hidden = true;
      this.filterToggle.setAttribute('aria-expanded', 'false');
      if (this.filter) this.filter.classList.remove('is-open');
    }

    resetFilters() {
      if (this.instock) this.instock.checked = false;
      this.currentCat = '';
      this.catButtons.forEach((b) => b.classList.toggle('is-active', b.getAttribute('data-cat-value') === ''));
      this.apply();
    }

    toggleSort() {
      if (this.sortMenu.hidden) this.openSort();
      else this.closeSort();
    }

    openSort() {
      this.closeFilter();
      this.sortMenu.hidden = false;
      this.sortToggle.setAttribute('aria-expanded', 'true');
      if (this.sortWrap) this.sortWrap.classList.add('is-open');
    }

    closeSort() {
      if (!this.sortMenu) return;
      this.sortMenu.hidden = true;
      this.sortToggle.setAttribute('aria-expanded', 'false');
      if (this.sortWrap) this.sortWrap.classList.remove('is-open');
    }

    selectSort(opt) {
      this.currentSort = opt.getAttribute('data-sort-value');
      this.sortOptions.forEach((o) => o.classList.toggle('is-active', o === opt));
      if (this.sortLabel) this.sortLabel.textContent = opt.textContent;
      this.closeSort();
      this.apply();
    }
  }

  if (!customElements.get('collection-grid')) {
    customElements.define('collection-grid', CollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  class VlpCountdown extends HTMLElement {
    connectedCallback() {
      this.timer = this.querySelector('[data-timer]');
      this.ended = this.querySelector('[data-ended]');
      this.fields = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      const target = new Date(this.dataset.deadline).getTime();
      if (isNaN(target)) return;
      this.target = target;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const diff = this.target - Date.now();
      if (diff <= 0) {
        this.finish();
        return;
      }
      const s = Math.floor(diff / 1000);
      this.set('days', Math.floor(s / 86400));
      this.set('hours', Math.floor((s % 86400) / 3600));
      this.set('minutes', Math.floor((s % 3600) / 60));
      this.set('seconds', s % 60);
    }

    set(key, value) {
      const el = this.fields[key];
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    finish() {
      clearInterval(this.interval);
      if (this.dataset.expired === 'true') {
        this.style.display = 'none';
        return;
      }
      if (this.timer) this.timer.hidden = true;
      if (this.ended && this.ended.textContent.trim()) this.ended.hidden = false;
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  if (!customElements.get('vlp-countdown')) {
    customElements.define('vlp-countdown', VlpCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class ImageZoom extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('.vlp-featured__img');
      this.button = this.querySelector('[data-zoom-toggle]');
      if (!this.img || !this.button) return;
      this.zoomed = false;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.setZoom(!this.zoomed);
      });
      this.addEventListener('mousemove', (event) => {
        if (this.zoomed) this.pan(event);
      });
      this.addEventListener('mouseleave', () => this.setZoom(false));
    }

    setZoom(on) {
      this.zoomed = on;
      this.classList.toggle('is-zoomed', on);
      if (on) {
        this.img.style.transform = 'scale(2.2)';
      } else {
        this.img.style.transform = '';
        this.img.style.transformOrigin = '';
      }
    }

    pan(event) {
      var rect = this.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      this.img.style.transformOrigin = x + '% ' + y + '%';
    }
  }

  if (!customElements.get('image-zoom')) {
    customElements.define('image-zoom', ImageZoom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class VlpMegaMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.vlp-header__shop-trigger');
      this.panel = this.querySelector('.vlp-header__mega');
      if (!this.trigger || !this.panel) return;
      this.closeTimer = null;

      this.addEventListener('mouseenter', () => {
        this.cancelClose();
        this.open();
      });
      this.addEventListener('mouseleave', () => this.scheduleClose());

      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });

      this.panel.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.close());
      });
    }

    scheduleClose() {
      this.cancelClose();
      this.closeTimer = setTimeout(() => this.close(), 220);
    }

    cancelClose() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }

    toggle() {
      if (this.classList.contains('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    ensureBackdrop() {
      if (this.backdrop) return this.backdrop;
      let el = document.querySelector('.vlp-menu-backdrop');
      if (!el) {
        el = document.createElement('div');
        el.className = 'vlp-menu-backdrop';
        document.body.appendChild(el);
      }
      el.addEventListener('click', () => this.close());
      this.backdrop = el;
      return el;
    }

    open() {
      document.querySelectorAll('vlp-mega-menu, vlp-search-menu, vlp-mobile-nav').forEach((el) => {
        if (el !== this && typeof el.close === 'function') el.close();
      });
      this.classList.add('open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.ensureBackdrop().classList.add('is-visible');
    }

    close() {
      this.cancelClose();
      this.classList.remove('open');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.backdrop) this.backdrop.classList.remove('is-visible');
    }
  }

  class VlpSearchMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-search-trigger]');
      this.panel = this.querySelector('.vlp-header__search-panel');
      this.input = this.querySelector('[data-search-input]');
      if (!this.trigger || !this.panel) return;

      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      });
    }

    ensureBackdrop() {
      if (this.backdrop) return this.backdrop;
      let el = document.querySelector('.vlp-menu-backdrop');
      if (!el) {
        el = document.createElement('div');
        el.className = 'vlp-menu-backdrop';
        document.body.appendChild(el);
      }
      el.addEventListener('click', () => this.close());
      this.backdrop = el;
      return el;
    }

    toggle() {
      if (this.classList.contains('open')) this.close();
      else this.open();
    }

    open() {
      document.querySelectorAll('vlp-mega-menu, vlp-search-menu, vlp-mobile-nav').forEach((el) => {
        if (el !== this && typeof el.close === 'function') el.close();
      });
      this.classList.add('open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.ensureBackdrop().classList.add('is-visible');
      if (this.input) window.requestAnimationFrame(() => this.input.focus());
    }

    close() {
      this.classList.remove('open');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.backdrop) this.backdrop.classList.remove('is-visible');
    }
  }

  class VlpMobileNav extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('[data-burger]');
      this.panel = this.querySelector('.vlp-header__mobile-panel');
      if (!this.burger || !this.panel) return;

      this.burger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.burger.focus();
        }
      });

      this.panel.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.close());
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > 768 && this.classList.contains('open')) this.close();
      });
    }

    ensureBackdrop() {
      if (this.backdrop) return this.backdrop;
      let el = document.querySelector('.vlp-menu-backdrop');
      if (!el) {
        el = document.createElement('div');
        el.className = 'vlp-menu-backdrop';
        document.body.appendChild(el);
      }
      el.addEventListener('click', () => this.close());
      this.backdrop = el;
      return el;
    }

    toggle() {
      if (this.classList.contains('open')) this.close();
      else this.open();
    }

    open() {
      document.querySelectorAll('vlp-mega-menu, vlp-search-menu, vlp-mobile-nav').forEach((el) => {
        if (el !== this && typeof el.close === 'function') el.close();
      });
      this.classList.add('open');
      this.burger.setAttribute('aria-expanded', 'true');
      this.ensureBackdrop().classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    close() {
      if (!this.classList.contains('open')) return;
      this.classList.remove('open');
      this.burger.setAttribute('aria-expanded', 'false');
      if (this.backdrop) this.backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('vlp-mega-menu')) {
    customElements.define('vlp-mega-menu', VlpMegaMenu);
  }
  if (!customElements.get('vlp-search-menu')) {
    customElements.define('vlp-search-menu', VlpSearchMenu);
  }
  if (!customElements.get('vlp-mobile-nav')) {
    customElements.define('vlp-mobile-nav', VlpMobileNav);
  }

  function vlpFooterHeaderSync() {
    const footer = document.querySelector('.vlp-footer');
    const header = document.querySelector('.vlp-header');
    if (!footer || !header || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        header.classList.toggle('is-hidden', entry.isIntersecting && window.scrollY > 0);
      });
    });
    observer.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vlpFooterHeaderSync);
  } else {
    vlpFooterHeaderSync();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  class VlpBgVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.removeAttribute('autoplay');
        this.video.style.display = 'none';
        this.video.pause();
      }
    }
  }

  if (!customElements.get('vlp-bg-video')) {
    customElements.define('vlp-bg-video', VlpBgVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  class VlpAddresses extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('select[data-default]').forEach((select) => {
        if (select.dataset.default) select.value = select.dataset.default;
      });

      this.querySelectorAll('[data-new-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.reveal(this.querySelector('[data-new-form]')));
      });

      this.querySelectorAll('[data-edit]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-edit');
          this.reveal(this.querySelector('[data-edit-form="' + id + '"]'));
          const row = btn.closest('[data-address]');
          if (row) {
            const view = row.querySelector('[data-view]');
            if (view) view.hidden = true;
          }
        });
      });

      this.querySelectorAll('[data-cancel]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const form = btn.closest('[data-new-form], [data-edit-form]');
          if (form) form.hidden = true;
          const row = btn.closest('[data-address]');
          if (row) {
            const view = row.querySelector('[data-view]');
            if (view) view.hidden = false;
          }
        });
      });

      this.querySelectorAll('[data-delete]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          if (!window.confirm(form.getAttribute('data-confirm'))) event.preventDefault();
        });
      });
    }

    reveal(el) {
      if (el) el.hidden = false;
    }
  }

  if (!customElements.get('vlp-addresses')) {
    customElements.define('vlp-addresses', VlpAddresses);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  class VlpAccountRecover extends HTMLElement {
    connectedCallback() {
      this.loginView = this.querySelector('[data-login]');
      this.recoverView = this.querySelector('[data-recover]');
      this.querySelectorAll('[data-recover-open]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.show('recover');
        });
      });
      this.querySelectorAll('[data-recover-close]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.show('login');
        });
      });
      if (window.location.hash === '#recover') this.show('recover');
    }

    show(view) {
      const recover = view === 'recover';
      if (this.loginView) this.loginView.hidden = recover;
      if (this.recoverView) this.recoverView.hidden = !recover;
    }
  }

  if (!customElements.get('vlp-account-recover')) {
    customElements.define('vlp-account-recover', VlpAccountRecover);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  class VlpMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vlp-mq__track');
      this.group = this.querySelector('.vlp-mq__group');
      if (!this.track || !this.group) return;
      if (!this.group.children.length) return;

      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);

      const speed = parseFloat(this.dataset.speed) || 60;
      this.applyDuration(speed);
      this.classList.add('is-animating');

      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(() => this.applyDuration(speed));
        this._ro.observe(this.group);
      }
    }

    applyDuration(speed) {
      const width = this.group.offsetWidth;
      if (!width) return;
      const duration = width / speed;
      this.track.style.animationDuration = duration + 's';
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
    }
  }

  if (!customElements.get('vlp-marquee')) {
    customElements.define('vlp-marquee', VlpMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class VariantSelector extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.addBtn = this.querySelector('[data-add-btn]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.mainImg = this.querySelector('[data-main-image]');
      this.form = this.querySelector('form');
      this.stockEl = this.querySelector('[data-stock]');
      this.lowStockThreshold = Number(this.dataset.lowStockThreshold) || 0;
      this.lowStockLabel = this.dataset.lowStockLabel || '';

      this.selected = [];
      const current = this.variants.find((v) => String(v.id) === String(this.idInput && this.idInput.value));
      if (current) {
        this.selected = current.options.slice();
        this.updateStock(current);
      }

      this.querySelectorAll('[data-value]').forEach((btn) => {
        btn.addEventListener('click', () => this.choose(btn));
      });
      this.galleryThumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.setImage(thumb.dataset.thumb, thumb));
        const preload = new Image();
        preload.src = thumb.dataset.thumb;
      });
      const galleryPrev = this.querySelector('[data-gallery-prev]');
      const galleryNext = this.querySelector('[data-gallery-next]');
      if (galleryPrev) galleryPrev.addEventListener('click', () => this.navigate(-1));
      if (galleryNext) galleryNext.addEventListener('click', () => this.navigate(1));

      this.main = this.querySelector('.vlp-pdp__main');
      this.zoomed = false;
      if (this.main && this.mainImg) {
        const zoomToggle = this.querySelector('[data-zoom-toggle]');
        if (zoomToggle) zoomToggle.addEventListener('click', () => this.setZoom(!this.zoomed));
        this.mainImg.addEventListener('click', () => this.setZoom(!this.zoomed));
        this.main.addEventListener('mousemove', (event) => {
          if (this.zoomed) this.panZoom(event);
        });
        this.main.addEventListener('mouseleave', () => this.setZoom(false));
        this.main.addEventListener(
          'touchmove',
          (event) => {
            if (this.zoomed && event.touches[0]) {
              this.panZoom(event.touches[0]);
              event.preventDefault();
            }
          },
          { passive: false }
        );
      }

      const copyBtn = this.querySelector('[data-copy-link]');
      if (copyBtn && navigator.clipboard) {
        copyBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(window.location.href).then(() => {
            copyBtn.classList.add('is-copied');
            setTimeout(() => copyBtn.classList.remove('is-copied'), 1600);
          });
        });
      }

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.submit(event));
      }
    }

    updateStock(variant) {
      if (!this.stockEl) return;
      const threshold = this.lowStockThreshold;
      if (threshold > 0 && variant && variant.available && variant.tracked && variant.inv > 0 && variant.inv <= threshold) {
        this.stockEl.textContent = this.lowStockLabel.replace('__n__', variant.inv);
        this.stockEl.hidden = false;
      } else {
        this.stockEl.hidden = true;
      }
    }

    choose(btn) {
      const position = Number(btn.dataset.position);
      const value = btn.dataset.value;
      this.selected[position - 1] = value;

      const group = btn.closest('[data-option-position]');
      if (group) {
        group.querySelectorAll('[data-value]').forEach((b) => {
          b.classList.toggle('is-selected', b === btn);
        });
        const colorLabel = group.querySelector('[data-color-label]');
        if (colorLabel) colorLabel.textContent = value;
      }
      this.update();
    }

    update() {
      const match = this.variants.find((v) => {
        return v.options.length === this.selected.length && v.options.every((o, i) => o === this.selected[i]);
      });
      if (!match) {
        if (this.addBtn) {
          this.addBtn.disabled = true;
          if (this.addLabel) this.addLabel.textContent = this.dataset.soldoutLabel;
        }
        this.updateStock(null);
        return;
      }

      this.updateStock(match);

      if (this.idInput) this.idInput.value = match.id;
      if (this.priceEl) this.priceEl.textContent = match.price;
      if (match.image && this.mainImg) {
        this.setZoom(false);
        this.mainImg.src = match.image;
        this.querySelectorAll('[data-thumb]').forEach((t) => {
          t.classList.toggle('is-selected', t.dataset.thumb === match.image);
        });
      }
      if (this.addBtn) {
        this.addBtn.disabled = !match.available;
        if (this.addLabel) {
          this.addLabel.textContent = match.available ? this.dataset.addLabel : this.dataset.soldoutLabel;
        }
      }
    }

    setImage(src, btn) {
      this.setZoom(false);
      if (this.mainImg) this.mainImg.src = src;
      this.querySelectorAll('[data-thumb]').forEach((t) => {
        t.classList.toggle('is-selected', t === btn);
      });
    }

    navigate(delta) {
      const thumbs = this.galleryThumbs || [];
      if (thumbs.length < 2) return;
      let index = thumbs.findIndex((t) => t.classList.contains('is-selected'));
      if (index < 0) index = 0;
      index = (index + delta + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      this.setImage(thumb.dataset.thumb, thumb);
    }

    setZoom(on) {
      if (!this.main || !this.mainImg) return;
      this.zoomed = on;
      this.main.classList.toggle('is-zoomed', on);
      if (on) {
        this.mainImg.style.transform = 'scale(2.4)';
      } else {
        this.mainImg.style.transform = '';
        this.mainImg.style.transformOrigin = '';
      }
    }

    panZoom(event) {
      const rect = this.main.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      this.mainImg.style.transformOrigin = x + '% ' + y + '%';
    }

    async submit(event) {
      if (!this.idInput) return;
      event.preventDefault();
      const quantityEl = this.form.querySelector('[name="quantity"]');
      const quantity = quantityEl ? Number(quantityEl.value) || 1 : 1;
      this.addBtn.setAttribute('disabled', '');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.idInput.value), quantity: quantity }] })
        });
        const data = await response.json();
        if (!response.ok) {
          var message = data && data.description ? data.description : this.dataset.errorLabel;
          document.dispatchEvent(new CustomEvent('vlp:cart:error', { detail: { message: message } }));
        } else {
          document.dispatchEvent(
            new CustomEvent('vlp:cart:added', { detail: { title: this.dataset.productTitle } })
          );
        }
      } catch (error) {
        document.dispatchEvent(new CustomEvent('vlp:cart:error', { detail: { message: this.dataset.errorLabel } }));
      } finally {
        this.addBtn.removeAttribute('disabled');
      }
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      const minus = this.querySelector('[data-qty-minus]');
      const plus = this.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => this.step(-1));
      if (plus) plus.addEventListener('click', () => this.step(1));
    }

    step(delta) {
      if (!this.input) return;
      let value = Number(this.input.value) || 1;
      value = Math.min(9, Math.max(1, value + delta));
      this.input.value = value;
    }
  }

  if (!customElements.get('variant-selector')) {
    customElements.define('variant-selector', VariantSelector);
  }
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class VlpVideo extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-play]');
      if (!this.button) return;
      this.button.addEventListener('click', () => this.load());
    }

    load() {
      const src = this.dataset.embed;
      if (!src) return;
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Video');
      this.innerHTML = '';
      this.appendChild(iframe);
    }
  }

  if (!customElements.get('vlp-video')) {
    customElements.define('vlp-video', VlpVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
